// extracted by mini-css-extract-plugin
export var dropdown = "_te-0";
export var imageWrapper = "_te-3";
export var itemNameContainer = "_te-1";
export var productImage = "_te-2";
export var spinnerWrapper = "_te-4";